'use strict';

// Constructor
var Toolbar = function() {

	$('body').on('click', function(e){
		var x = $(e.target).is('.profile, .profile *');
		if(!x){
			$('.mycevn').removeClass('active');
		}
	});

	//Toolbar search
	$('.toolbarsearch > div.icomoon-search').on('click', function(e){
		$('.toolbarsearch .search').toggleClass('active');
		$('.toolbarsearch').toggleClass('active');
	});

	//Toolbar profile
	$('.profile .icomoon-profile').on('click', function(e){
			$('.mycevn').toggleClass('active');
			console.log('click');
			e.preventDefault;
 	});

	// //Keep option selected
	// var url = new URL(document.location);
  // 	var params = url.searchParams;
	// var current = params.get('code');
	// $('option[code*='+current+']').attr('selected','selected');
	// //Change homepage to diocese
	// $('.zones select').on('change', function(e){
	// 	console.log(params.get('code'));
	// 	var code = $('option:selected', this).attr('code');
	// 	window.location.href = "/"+e.target.value+"?code="+code;
	//
	// });
}

module.exports = Toolbar;
